import React from 'react';
import call from "../library/svg/call.svg";
import mail from "../library/svg/mail.svg";
import location from "../library/svg/location.svg";

const Contact = () => {
    return (
        <>
            <p>Contact Us</p>
            <p>Health Science Team</p>
            <hr />
            <div className="contact_data_container">
                {[
                    {
                        name: "M R, Anush Prabha",
                        phone: "+91 444 299 4905",
                        email: "a.mr@elsevier.com"
                    },
                    {
                        name: "Nandhini Sampath",
                        phone: "+91 444 299 4913",
                        email: "N.S@elsevier.com"
                    },
                    {
                        name: "Mohana Krishnan D",
                        phone: "+91 444 299 4904",
                        email: "m.devaraj@elsevier.com"
                    },
                    {
                        name: "Chandrasekhar Reddy",
                        phone: "+91 444 299 4901",
                        email: "c.b@elsevier.com"
                    },
                    {
                        name: "Sonali Pandiyan",
                        phone: "+91 444 299 4902",
                        email: "s.pandiyan@elsevier.com"
                    },
                    {
                        name: "Ferdinand Lourdu Samy",
                        phone: "+91 444 299 4906",
                        email: "f.lourdusamy@elsevier.com"
                    }
                ].map((contact, index) => (
                    <div className="contact-data" key={index}>
                        <strong className="title-support">{contact.name}</strong>
                        <span className="font-16">
                            <img src={call} className="margin-right-10p" alt="call" />
                            {contact.phone}
                        </span>
                        <br />
                        <span className="font-16">
                            <img src={mail} className="margin-right-10p" alt="mail" />
                            {contact.email}
                        </span>
                    </div>
                ))}
            </div>
            <hr className="margin-bottom-50" />
            <p>Any Escalations</p>
            <hr />
            <div className="contact_data_container">
                {[
                    {
                        name: "Hussain S Banswadawala",
                        phone: "+91 444 299 4903",
                        email: "h.banswadawala@elsevier.com"
                    },
                    {
                        name: "Joe Joseph",
                        phone: "+91 7305342444",
                        email: "j.joseph.1@elsevier.com"
                    }
                ].map((contact, index) => (
                    <div className="contact-data" key={index}>
                        <strong className="title-support">{contact.name}</strong>
                        <span className="font-16">
                            <img src={call} className="margin-right-10p" alt="call" />
                            {contact.phone}
                        </span>
                        <br />
                        <span className="font-16">
                            <img src={mail} className="margin-right-10p" alt="mail" />
                            {contact.email}
                        </span>
                    </div>
                ))}
            </div>
            <hr className="margin-bottom-50" />
            <p>Regional Account Manager</p>
            <hr />
            <div className="contact_data_container">
                {[
                    {
                        name: "Abinash Sahu",
                        location: "West Bengal (East)",
                        phone: "+91 8373913877, +91 9937011218",
                        email: "a.sahu@elsevier.com"
                    },
                    {
                        name: "Atul Patil",
                        location: "Maharashtra (West)",
                        phone: "+91 9811514225, +91 9860564672",
                        email: "a.patil@elsevier.com"
                    },
                    {
                        name: "Pawan Mishra",
                        location: "Gujarat & Madhya Pradesh (West)",
                        phone: "+91 9727084545, +91 8860086413",
                        email: "MISHRAP12@ReedElsevier.com"
                    },
                    {
                        name: "A, Paul Antony",
                        location: "Tamil Nadu & Kerala (South)",
                        phone: "+91 9791707714",
                        email: "p.antony@elsevier.com"
                    },
                    {
                        name: "M Purnachary",
                        location: "Andhra Pradesh & Karnataka (South)",
                        phone: "+91 8448595909, +91 9866239333",
                        email: "m.purnachary@elsevier.com"
                    },
                    {
                        name: "Rajeev Sharma",
                        location: "Delhi (North)",
                        phone: "+91 9311057771",
                        email: "r.sharma.4@elsevier.com"
                    }
                ].map((contact, index) => (
                    <div className="contact-data" key={index}>
                        <strong className="title-support">{contact.name}</strong>
                        <span className="font-16">
                            <img src={location} className="margin-right-10p" alt="location" />
                            {contact.location}
                        </span>
                        <br />
                        <span className="font-16">
                            <img src={call} className="margin-right-10p" alt="call" />
                            {contact.phone}
                        </span>
                        <br />
                        <span className="font-16">
                            <img src={mail} className="margin-right-10p" alt="mail" />
                            {contact.email}
                        </span>
                    </div>
                ))}
            </div>
            <hr className="margin-bottom-50" />
            <p>Any Escalations</p>
            <hr />
            <div className="contact_data_container">
                {[
                    {
                        name: "Umesh Taneja",
                        location: "Retail Channels (North & East)",
                        phone: "+91 9810693974, +91 124 4774336",
                        email: "U.Taneja@elsevier.com"
                    },
                    {
                        name: "Vishal Varghese",
                        location: "Retail Channels (South & West)",
                        phone: "+91 7718033300, +91 9599077967",
                        email: "v.varghese@elsevier.com"
                    }
                ].map((contact, index) => (
                    <div className="contact-data" key={index}>
                        <strong className="title-support">{contact.name}</strong>
                        <span className="font-16">
                            <img src={location} className="margin-right-10p" alt="location" />
                            {contact.location}
                        </span>
                        <br />
                        <span className="font-16">
                            <img src={call} className="margin-right-10p" alt="call" />
                            {contact.phone}
                        </span>
                        <br />
                        <span className="font-16">
                            <img src={mail} className="margin-right-10p" alt="mail" />
                            {contact.email}
                        </span>
                    </div>
                ))}
            </div>
        </>
    );
};

export default Contact;